import React from "react";
import {Route, Router, Switch} from "react-router-dom";
import {
  homePathGenerator, parseRouting,
  setPageTitle,
  slugify, storeActiveHome, storeActiveSection,
  translateTypes
} from "../../api-client/core/authentication/utils";
import {request} from "../../api-client";
import Footer from "../Home/HomeElements/Footer";
import Home from "./Home";
import Navbar from "./Navbar";
import TalentProfile from "./TalentProfile/index.jsx";
import SmartSearch from "./SmartSearch"
import Browse from "./Browse";
import Drive from "./Drive";
import Reels from "./Reels";
import About from "./About";
import Projects from "./Projects";
import SmartSearchContentCreation from "../Home/SmartSearch/SmartSearchContentCreation";
import SmartSearchContentCreator from "../Home/SmartSearch/SmartSearchContentCreator";
import ContentCreator from "../Home/ContentCreator/";
import Contact from "../Home/Contact";
import LiveStreamCarousel from "./LiveStream/Carousel";
import LiveStream from "./LiveStream";
import ErrorPage from "./ErrorPage";
import browserHistory from "../../utils/browserHistory";
import LoginChannel from "../../views/Login";
import Register from "../../views/Register";
import ForgotPassword from "../../views/ChannelLogin/ForgotPassword/ForgotPassword";
import ResetPassword from "../../views/ResetPassword";
import SetPassword from "../../views/ChannelLogin/Activate/SetPassword";
import CompleteRegister from "../../views/ChannelLogin/Activate/CompleteRegister";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle} from "@material-ui/core";
import EventManager, {events} from "../../utils/EventManager";
import qs from "qs";
import AuthorizationCode from "./Authorization/Code.jsx"
import localization from "../../config/localization";
import Favorites from "./Favorites";
import HomePlaylists from "./Playlists/HomePlaylists";
import HomePlaylist from "./Playlists/Playlist";
import Links from "./Links";


const transparentRoutes = ['/playlist', '/content_creator'];
const transparentExcludeRoutes = ['smart_search', 'playlists', 'account', 'original_music', '/edit'];
const excludeNavbarAndFooterRoutes = ['login', 'register', 'password/forgot', 'set-password', 'error-page'];

const getIdFromUrl = () => {
  if (!window.location.pathname.startsWith('/home')) return false;
  let clientData = window.location.pathname.split('/')[2]

  return Number(clientData && clientData.split("-")[0])
}
const getNameFromUrl = () => {
  if (!window.location.pathname.startsWith('/home')) return false;
  let clientData = window.location.pathname.split('/')[2]

  return clientData && clientData.split("-")[1]
}

class HomeRouting extends React.Component {
  state = {
    notNavbar: false,
    homeElements: [],
    hasDomain: false,
    loaded: false,
    showModal: false,
    limitReached: false,
  };

  componentDidMount = () => {
    storeActiveHome(true);
    request.home.getMetadata(getIdFromUrl())
      .then(homeElements => this.setState({homeElements}))
      .then(() => this.setState({loaded: true}));

    if (getIdFromUrl()) storeActiveSection({id: getIdFromUrl(), name: getNameFromUrl()})
    this.checkIfNavbarIsTransparent()
    EventManager.getInstance().subscribe(events.OPEN_CONTENT_MODAL, this.openModal)
    EventManager.getInstance().subscribe(events.OPEN_VIEWS_LIMIT_MODAL, this.openViewsLimitModal)

    window.onpopstate = () => {
      if (this.state.showModal) {
        // Do your stuff
        this.handleClose()
      }
    };
  };

  componentWillUnmount = () => {
    EventManager.getInstance().unsubscribe(events.OPEN_CONTENT_MODAL, this.openModal)
    EventManager.getInstance().unsubscribe(events.OPEN_VIEWS_LIMIT_MODAL, this.openViewsLimitModal)
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.setState({showModal: false})
      this.checkIfNavbarIsTransparent()
    }
  };

  checkIfNavbarIsTransparent = () =>
    this.setState({
      notNavbar: (
        excludeNavbarAndFooterRoutes.some(transparentRoute => this.props.location.pathname.indexOf(transparentRoute) > -1)
      )
    });

  MyList = (props) => <HomePlaylists {...props}/>
  Favorites = (props) => <Favorites  {...props}/>
  SmartSearch = (props) => <SmartSearch  {...props}/>
  SmartSearchContentCreator = (props) => <SmartSearchContentCreator  {...props}/>
  SmartSearchContentCreation = (props) => <SmartSearchContentCreation  {...props}/>
  ContentCreator = (props) => <ContentCreator contentCreatorId={props.match.params.contentCreatorId} {...props}/>
  Browse = (props) => <Browse elementId={props.match.params.elementId}  {...props}/>
  Contact = props => <Contact onSubmit={(name, email, description) => request.channel.contact(name, email, description)} afterSubmit={() => browserHistory.push(homePathGenerator(``))} {...props}/>
  LiveStreamCarousel = props => <LiveStreamCarousel  {...props}/>
  LiveStream = props => <LiveStream  {...props}/>
  Login = props => <LoginChannel  {...props}/>
  Register = props => <Register  {...props}/>
  CompleteRegister = props => <CompleteRegister  {...props}/>
  ForgotPassword = props => <ForgotPassword  {...props}/>
  ResetPassword = props => <ResetPassword  {...props}/>
  SetPassword = props => <SetPassword  {...props}/>
  AuthorizationCode = (props) => <AuthorizationCode  {...props}/>
  ErrorPage = (props) => <ErrorPage  {...props}/>
  // ChannelPlaylist = (props) => <ChannelPlaylist  {...props}/>
  Projects = (props) => <Projects {...props}/>
  Home = props => <Home {...props} showModal={this.state.showModal} homeElements={this.state.homeElements.filter(element => element.type !== "navbar")} />
  Drive = props => <Drive {...props}/>
  Reels = props => <Reels {...props}/>
  HomePlaylist = props => <HomePlaylist {...props}/>
  About = props => <About {...props}/>
  TalentProfile = (props) => <TalentProfile {...props}/>
  Links = (props) => <Links {...props}/>



  openModal = data => {
    let queryString = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
      depth: 2,
      plainObjects: true,
    })
    queryString = {...queryString, [translateTypes(data.dataType)]: `${data.id}-${slugify(data.dataName)}`}

    browserHistory.push({
      search: qs.stringify(queryString),
    });

    this.setState({modalEntityId: data.id, entityType: translateTypes(data.dataType), showModal: true, onTagChange: data.onTagChange || false})
  }

  openViewsLimitModal = () => this.setState({limitReached: true})

  replaceUrlParameters = () => {
    const queryString = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
      depth: 2,
      plainObjects: true,
    })

    delete queryString.contenido

    browserHistory.push({
      search: qs.stringify(queryString),
    });
  }

  handleClose = () => {
    this.replaceUrlParameters()
    this.setState({showModal: false, limitReached: false, showModalFooter: false})
    setPageTitle()
  }
  renderShowModal = () =>
    <Dialog
      open={this.state.showModal}
      onEscapeKeyDown={this.handleClose}
      fullScreen={true}
      disableEnforceFocus
    >
      {this.state.entityType === "contenido" &&
      <>
        <ContentCreator onShowModalFooter={() => this.setState({showModalFooter: true})} contentCreatorId={this.state.modalEntityId} modal={true} onModalClose={this.handleClose} onTagChange={this.state.onTagChange} {...this.props}/>
      </>
      }
    </Dialog>

  renderViewLimitReachedDialog = () =>
    <Dialog
      open={this.state.limitReached}
      onEscapeKeyDown={this.handleClose}
      onBackdropClick={this.handleClose}
    >
      <DialogTitle>{localization.get("content.views_limit_reached")}</DialogTitle>
      <DialogContent>{localization.get("content.views_limit_reached.description")}</DialogContent>
      <DialogActions>
        <Button onClick={() => this.handleClose()}>{localization.get('form.close')}</Button>
      </DialogActions>
    </Dialog>


  render = () => {
    if (this.state.loaded) {
      return (
        <div>
          {!this.state.notNavbar && this.state.homeElements &&
            <Navbar transparentMode={this.state.transparent} {...this.props} navbarElements={this.state.homeElements.filter(element => element.type === "navbar")}/>
          }
          <div style={{backgroundColor: "white", paddingTop: this.state.notNavbar ? 0 : 50}} id="wrapper">
            <div id="inner">
              {this.renderShowModal()}
              {this.renderViewLimitReachedDialog()}
              <Router {...this.props}>
                <Switch>
                  <Route path={parseRouting("browse/:elementId-:elementName")} render={wrap(this.Browse)}/>
                  <Route path={parseRouting("contacto")} render={wrap(this.Contact)}/>
                  <Route path={parseRouting("vivos")} render={wrap(this.LiveStreamCarousel)}/>
                  <Route path={parseRouting("vivo/:livestreamId-:livestreamName")} render={wrap(this.LiveStream)}/>
                  <Route path={parseRouting("login")} render={wrap(this.Login)}/>
                  <Route path={parseRouting("register")} render={wrap(this.Register)}/>
                  <Route path={parseRouting("password/forgot")} render={wrap(this.ForgotPassword)}/>
                  <Route path={parseRouting("password/reset")} render={wrap(this.ResetPassword)}/>
                  <Route path={parseRouting("set-password")} render={wrap(this.SetPassword)}/>
                  <Route path={parseRouting("user/activation")} render={wrap(this.CompleteRegister)}/>
                  <Route path={parseRouting("login-code")} render={wrap(this.AuthorizationCode)}/>
                  <Route path={parseRouting("contenido/:contentCreatorId-:contentCreatorName")} render={wrap(this.ContentCreator)}/>
                  <Route path={parseRouting("mi-lista")} render={wrap(this.MyList)}/>
                  <Route path={parseRouting("error-page")} render={wrap(this.ErrorPage)}/>
                  <Route path={parseRouting("mi-perfil")} render={wrap(this.TalentProfile)}/>
                  <Route path={parseRouting("busqueda-inteligente")} render={wrap(this.SmartSearch)}/>
                  <Route path={parseRouting("favoritos")} render={wrap(this.Favorites)} />
                  <Route path={parseRouting("playlist/:playlistId")} render={wrap(this.HomePlaylist)} />
                  <Route path={parseRouting("playlists")} render={wrap(this.HomePlaylists)} />
                  <Route path={parseRouting("projects")} render={wrap(this.Projects)} />
                  <Route path={parseRouting("links")} render={wrap(this.Links)} />
                  <Route path={parseRouting("drive")} render={wrap(this.Drive)} />
                  <Route path={parseRouting("reels")} render={wrap(this.Reels)} />
                  <Route path={parseRouting("contact")} render={wrap(this.Contact)} />
                  <Route path={parseRouting("about")} render={wrap(this.About)} />
                  <Route path={parseRouting("")} render={wrap(this.Home)} />
                </Switch>
              </Router>
            </div>
            {!this.state.notNavbar && <Footer {...this.props} />}
          </div>
        </div>
      );
    } else {
      return (<></>)
    }

  };
}

const wrap = (Comp) => props => {
  return <Comp {...props}/>
}

export default HomeRouting;
